<template>
  <div v-if="isExtensionInstalled" class="top-0 w-full bg-green-100 px-4 py-2 text-center text-green-500 dark:bg-green-600 dark:text-green-50">
    <div class="flex items-center justify-center">
      <CheckCircleIcon class="mr-2 h-6 w-6" />
      <div>Wisery Chrome extension installed</div>
    </div>
  </div>
  <div class="mx-auto mt-10 max-w-6xl px-4 sm:px-6 lg:px-8">
    <!-- How to save pages -->
    <h2 class="mt-2 text-lg font-semibold tracking-tight text-gray-900 dark:text-white sm:text-4xl">How to save content</h2>

    <div class="mt-16">
      <div class="mb-10 hidden gap-x-2 text-center sm:grid sm:grid-cols-4">
        <div class="relative col-span-3 h-6 rounded-t border-t-2 border-l-2 border-r-2 border-gray-300 dark:border-gray-700">
          <div class="absolute inset-x-0 -top-7 dark:text-white">Desktop</div>
        </div>
        <div class="relative col-span-1 h-6 rounded-t border-t-2 border-l-2 border-r-2 border-gray-300 dark:border-gray-700">
          <div class="absolute inset-x-0 -top-7 dark:text-white">Mobile</div>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-y-10 sm:grid-cols-4 sm:gap-4">
        <!-- Extension icon -->
        <div class="relative rounded-md bg-white/10 p-4 shadow-lg dark:border dark:border-violet-900/80 dark:bg-gray-500 dark:bg-violet-900/10 dark:shadow-violet-900/60 sm:p-6">
          <div class="absolute inset-x-0 -top-7 flex w-full justify-center text-center">
            <div class="relative flex h-14 w-14 items-center justify-center rounded-full bg-gray-500 p-2 text-center text-xl shadow-md dark:bg-violet-900">
              <PuzzleIcon class="h-8 w-8 text-white" />
            </div>
          </div>
          <p class="mt-5 mb-5 border-b border-gray-200 pb-2 text-lg font-medium text-gray-900 dark:text-white">Click extension icon</p>
          <div class="text-gray-900 dark:text-white">
            <!-- <li>
              <img src="../assets/how-to-pin-extension.svg" alt="How to pin Wisery Chrome extension" class="w-full mt-3" />
            </li> -->

            <img src="../assets/how-to-save-from-extension.svg" alt="How to save content with Wisery's Chrome extension" class="mx-auto dark:hidden" />
            <img src="../assets/how-to-save-from-extension-dark.svg" alt="How to save content with Wisery's Chrome extension" class="mx-auto hidden dark:block" />
          </div>
        </div>

        <!-- Keyboard shortcut  -->
        <div class="relative rounded-md bg-white/10 p-4 shadow-lg dark:border dark:border-violet-900/80 dark:bg-gray-500 dark:bg-violet-900/10 dark:shadow-violet-900/60 sm:p-6">
          <div class="absolute inset-x-0 -top-7 flex w-full justify-center text-center">
            <div class="relative flex h-14 w-14 items-center justify-center rounded-full bg-gray-500 p-2 text-center text-xl shadow-md dark:bg-violet-900">
              <LightningBoltIcon class="h-8 w-8 text-white" />
            </div>
          </div>
          <p class="mt-5 mb-5 border-b border-gray-200 pb-2 text-lg font-medium text-gray-900 dark:text-white">Keyboard shortcut</p>
          <img v-if="isMac" src="../assets/extension-commands-mac.svg" alt="How to pin Wisery Chrome extension" class="mt-3 w-full" />
          <img v-else src="../assets/extension-commands-win.svg" alt="How to pin Wisery Chrome extension" class="mt-3 w-full" />
        </div>

        <!-- Context Menu -->
        <div class="relative rounded-md bg-white/10 p-4 shadow-lg dark:border dark:border-violet-900/80 dark:bg-gray-500 dark:bg-violet-900/10 dark:shadow-violet-900/60 sm:p-6">
          <div class="absolute inset-x-0 -top-7 flex w-full justify-center text-center">
            <div class="relative flex h-14 w-14 items-center justify-center rounded-full bg-gray-500 p-2 text-center text-xl shadow-md dark:bg-violet-900">
              <CursorClickIcon class="h-8 w-8 text-white" />
            </div>
          </div>
          <p class="mt-5 mb-5 border-b border-gray-200 pb-2 text-lg font-medium text-gray-900 dark:text-white">Select and right-click</p>
          <img src="../assets/context-menu.svg" alt="how to save from context menu" class="mt-3 w-full" />
        </div>

        <!-- Bookmarking (on mobile) -->
        <div class="relative rounded-md bg-white/10 p-4 shadow-lg dark:border dark:border-violet-900/80 dark:bg-gray-500 dark:bg-violet-900/10 dark:shadow-violet-900/60 sm:p-6">
          <div class="absolute inset-x-0 -top-7 flex w-full justify-center text-center">
            <div class="relative flex h-14 w-14 items-center justify-center rounded-full bg-gray-500 p-2 text-center text-xl shadow-md dark:bg-violet-900">
              <StarIcon class="absolute h-10 w-10 text-white" />
              <PlusIcon class="absolute h-4 w-4 font-extrabold text-gray-600" />
            </div>
          </div>
          <p class="mt-5 mb-5 border-b border-gray-200 pb-2 text-lg font-medium text-gray-900 dark:text-white">Add bookmark to "Wisery" folder</p>
          <img src="../assets/bookmark-mobile.svg" alt="Bookmark to save to Wisery" class="mt-3 w-full" />
        </div>
      </div>
    </div>

    <div class="my-16">
      <div class="text-white-600 rounded-lg bg-blue-500 p-6 text-white shadow-lg shadow-gray-300">
        <div class="flex items-center justify-between">
          <div>
            <div class="mb-2 text-2xl font-bold">Try it out now</div>
            <div class="text-lg">Visit your favorite blog, news site, YouTube chanel,... and save it with Wisery's Chrome extension.</div>
          </div>
          <div>
            <ArrowDownIcon class="hidden h-12 w-12 sm:flex" />
          </div>
        </div>
      </div>
    </div>

    <div class="mb-20 block w-full sm:flex sm:space-x-5">
      <template v-for="source in sources" :key="source">
        <div class="mt-10 w-full sm:w-1/4">
          <p class="mb-3 font-bold capitalize text-gray-900 dark:text-white">{{ source.name }}</p>
          <div class="space-y-2">
            <template v-for="site in source.items" :key="site">
              <div class="rounded-md border border-gray-300 p-4">
                <a :href="site.url" target="_self" class="block">
                  <div class="flex items-center justify-between overflow-hidden">
                    <div>
                      <div class="block text-gray-900 dark:text-white">{{ site.name }}</div>
                      <div class="block text-sm text-gray-400">{{ site.url }}</div>
                    </div>
                    <ExternalLinkIcon class="h-5 w-5 text-gray-400" />
                  </div>
                </a>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { ExternalLinkIcon, PlusIcon, CheckCircleIcon } from "@heroicons/vue/outline";
import { PuzzleIcon, CursorClickIcon, StarIcon, LightningBoltIcon, ArrowDownIcon } from "@heroicons/vue/solid";
import { onMounted, ref, watchEffect } from "vue";
import utilFunctions from "../composables/util";
import chromeExtension from "../composables/chromeExtension";
import firebaseUser from "../composables/userAuth";
import { db } from "../firebase";
import { doc, updateDoc } from "@firebase/firestore";
export default {
  name: "ChromeExtension",
  components: { ExternalLinkIcon, CheckCircleIcon, ArrowDownIcon, PuzzleIcon, CursorClickIcon, LightningBoltIcon, StarIcon, PlusIcon },
  setup() {
    const { user } = firebaseUser();
    const { extensionInstalled } = utilFunctions();
    const isExtensionInstalled = ref(false);
    const sources = {
      news: {
        name: "news",
        items: [
          { name: "The Economist", url: "https://www.economist.com/" },
          { name: "Financial Times", url: "https://www.ft.com/" },
          { name: "The New York Times", url: "https://www.nytimes.com/" },
          { name: "The Wall Street Journal", url: "https://www.wsj.com/" },
          { name: "The Washington Post", url: "https://www.washingtonpost.com/" },
          { name: "The Atlantic", url: "https://www.theatlantic.com/" },
          { name: "The Associated Press", url: "https://apnews.com/" },
          { name: "Bloomberg", url: "https://www.bloomberg.com/" },
        ],
      },
      tech: {
        name: "tech",
        items: [
          { name: "Stratechery", url: "https://stratechery.com/" },
          { name: "The Verge", url: "https://www.theverge.com/" },
          { name: "The Next Web", url: "https://thenextweb.com/" },
          { name: "Engadget", url: "https://www.engadget.com/" },
          { name: "CNET", url: "https://www.cnet.com/" },
          { name: "Ars Technica", url: "https://arstechnica.com/" },
          { name: "VentureBeat", url: "https://venturebeat.com/" },
        ],
      },
      productivity: {
        name: "productivity",
        items: [
          { name: "Farnam Street", url: "https://fs.blog/" },
          { name: "Tim Ferriss", url: "https://tim.blog/" },
          { name: "Barking Up The Wrong Tree", url: "https://www.bakadesuyo.com/" },
          { name: "Marginal Revolution", url: "https://marginalrevolution.com/" },
          { name: "Slate Star Codex", url: "https://slatestarcodex.com/" },
          { name: "The Marginalian", url: "https://www.themarginalian.org/" },
          { name: "Zen Habits", url: "https://zenhabits.net/" },
          { name: "The School of Life", url: "https://www.theschooloflife.com/" },
        ],
      },
      startups: {
        name: "startups",
        items: [
          { name: "OnStartups", url: "http://onstartups.com/" },
          { name: "a16z Future", url: "https://future.a16z.com/" },
          { name: "Andrew Chen", url: "http://andrewchen.co/" },
          { name: "Above the Crowd", url: "https://abovethecrowd.com/" },
          { name: "Paul Graham", url: "http://www.paulgraham.com/articles.html" },
          { name: "Sam Altman", url: "https://blog.samaltman.com/" },
          { name: "First Round Review", url: "https://review.firstround.com/" },
          { name: "Chris Dixon", url: "https://cdixon.org/" },
          { name: "Hunter Walk", url: "https://hunterwalk.com/" },
        ],
      },
    };

    watchEffect(async () => {
      if (user.value) {
        try {
          extensionInstalled(chromeExtension.id, chromeExtension.image, async (installed) => {
            isExtensionInstalled.value = installed;
            if (isExtensionInstalled.value) {
              // update user doc channels
              // user doc ref
              const userDocRef = doc(db, "users", user.value.uid);
              await updateDoc(
                userDocRef,
                {
                  "channels.chrome": {
                    id: chromeExtension.id,
                    notifications: true,
                  },
                },
                { merge: true }
              );
            }
          });
        } catch (error) {
          console.log(error);
        }
      }
    });

    const isMac = ref(true);
    onMounted(() => {
      isMac.value = navigator.userAgentData.platform.toLowerCase().indexOf("mac") >= 0 ? true : false;
    });

    return { sources, isMac, isExtensionInstalled };
  },
};
</script>
